function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Table, message, Drawer, Modal, Select, Form, DatePicker, Collapse, notification, Breadcrumb } from 'antd';
import Common from '../components/includes/Common';
import { Truck, Plus } from 'react-bootstrap-icons';
import AddOrder from '../components/forms/AddOrder';
import OrderListView from '../components/OrderListView';
import moment from "moment";
import AddProvider from '../components/forms/AddProvider';
import AddProvidingPurchaseOrder from '../components/forms/AddProvidingPurchaseOrder';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Provider = function Provider() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    providersList = _useState2[0],
    setProvidersList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataChanged = _useState4[0],
    setIsDataChanged = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedProvider = _useState8[0],
    setSelectedProvider = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isNewOrderOpen = _useState0[0],
    setIsNewOrderOpen = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    stationsOptions = _useState10[0],
    setStationsOptions = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedStation = _useState12[0],
    setSelectedStation = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    stationsList = _useState14[0],
    setStationsList = _useState14[1];
  var _useState15 = useState(moment().startOf('month').format()),
    _useState16 = _slicedToArray(_useState15, 2),
    orderFrom = _useState16[0],
    setOrderFrom = _useState16[1];
  var _useState17 = useState(moment().endOf('month').format()),
    _useState18 = _slicedToArray(_useState17, 2),
    orderTo = _useState18[0],
    setOrderTo = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    orderList = _useState20[0],
    setOrderList = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showAddProvider = _useState22[0],
    setShowAddProvider = _useState22[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 2),
    form = _Form$useForm2[0],
    orderform = _Form$useForm2[1];
  var handleNewOrder = function handleNewOrder(provider) {
    setSelectedProvider(provider);
    setIsNewOrderOpen(true);
  };
  var onOrderSearchFinish = function onOrderSearchFinish(value) {};
  var cols = [{
    title: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(Truck, {
        size: 25
      }), " Fournisseur"]
    }),
    dataIndex: 'label',
    key: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: 'Balance',
    dataIndex: 'balance',
    key: 'balance',
    render: function render(text) {
      return /*#__PURE__*/_jsxs("b", {
        children: [text.toLocaleString('Fr'), " GNF"]
      });
    }
  }, {
    title: 'E-mail',
    responsive: ['lg', 'md'],
    dataIndex: 'email',
    key: 'label',
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    }
  }, {
    title: 'Action',
    dataIndex: 'provider',
    key: 'provider',
    render: function render(provider) {
      return /*#__PURE__*/_jsx(Space, {
        direction: "horizontal",
        children: /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            handleNewOrder(provider);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: "FAIRE UNE COMMANNDE"
          })
        })
      });
    }
  }];
  var getAllData = function getAllData() {
    setIsDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + 'getproviders/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getsellables/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getprovidingorders/' + Common.currentUser.id + "/" + orderFrom + "/" + orderTo)]).then(function (response) {
      setIsDataLoading(true);
      if (response[0].data.status == 200) {
        setProvidersList([]);
        response[0].data.providers.forEach(function (p) {
          setProvidersList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: p.id,
              label: p.label,
              balance: p.balance,
              email: p.email,
              provider: p
            }]);
          });
        });
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
      setOrderList([]);
      if (response[2].data.status == 200) {
        setOrderList(response[2].data.orders);
      } else {
        message.error({
          content: "Une erreur est survenue",
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    getAllData();
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Breadcrumb, {
            items: [{
              title: /*#__PURE__*/_jsx("span", {
                children: "ALO-GAZ"
              })
            }, {
              title: "Fournisseurs"
            }]
          }), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx(Space, {
            direction: "horizontal",
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              icon: /*#__PURE__*/_jsx(Plus, {}),
              onClick: function onClick() {
                setShowAddProvider(true);
              },
              children: /*#__PURE__*/_jsx("b", {
                children: " CREER UN FOURNISSEUR"
              })
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
            columns: cols,
            bordered: true,
            loading: isDataLoading,
            size: "small",
            pagination: false,
            dataSource: providersList
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            style: {
              padding: "8px",
              borderRadius: "8px",
              marginBottom: "14px",
              background: "#FDEBE2"
            },
            children: /*#__PURE__*/_jsx(Collapse, {
              ghost: true,
              items: [{
                key: 1,
                label: /*#__PURE__*/_jsx("b", {
                  children: "Filtrer par p\xE9riode"
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsx(Form, {
                    form: orderform,
                    layout: "horizontal",
                    onFinish: onOrderSearchFinish,
                    children: /*#__PURE__*/_jsxs(Row, {
                      children: [/*#__PURE__*/_jsx(Col, {
                        lg: 4,
                        md: 5,
                        sm: 8,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          name: "period",
                          rules: [{
                            required: true,
                            message: 'Champ obligatoire'
                          }],
                          children: /*#__PURE__*/_jsx(RangePicker, {})
                        })
                      }), /*#__PURE__*/_jsx(Col, {
                        lg: 1,
                        md: 3,
                        sm: 4,
                        children: /*#__PURE__*/_jsx(Form.Item, {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            htmlType: "submit",
                            children: /*#__PURE__*/_jsx("b", {
                              children: "RECHERCHE"
                            })
                          })
                        })
                      })]
                    })
                  })
                })
              }]
            })
          }), /*#__PURE__*/_jsx(OrderListView, {
            orderList: orderList,
            loading: setIsDataLoading,
            dataRefreshHandler: function dataRefreshHandler() {
              setIsDataChanged(true);
            }
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER UN FOURNISSEUR"
      }),
      footer: null,
      destroyOnClose: true,
      open: showAddProvider,
      onCancel: function onCancel() {
        setShowAddProvider(false);
      },
      width: {
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%'
      },
      children: /*#__PURE__*/_jsx(AddProvider, {
        handler: function handler() {
          setIsDataChanged(true);
          setShowAddProvider(false);
          notification.success({
            message: "Ok!",
            description: "Opération éffectuée"
          });
        }
      })
    }), selectedProvider != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["Commande - ", selectedProvider.label]
      }),
      width: "395px",
      destroyOnClose: true,
      open: isNewOrderOpen,
      onClose: function onClose() {
        setIsNewOrderOpen(false);
      },
      children: /*#__PURE__*/_jsx(AddProvidingPurchaseOrder, {
        provider: selectedProvider,
        handler: function handler() {
          setIsNewOrderOpen(false);
          setIsDataChanged(true);
          notification.success({
            message: "Ok!",
            description: 'La commande est créée et en attente de validation'
          });
        }
      })
    })]
  });
};
export default Provider;